import { createSlice } from '@reduxjs/toolkit';

import { isNativePlatform } from 'services/auth/platform';
import { getConfig } from 'services/config/runtimeConfig';

// Projection of the runtime tenant config (services/config/runtimeConfig) into redux.
// The authoritative store is @capacitor/preferences via runtimeConfig.
// This slice is NOT persisted (it is rehydrated from runtimeConfig at boot).
// On web there is always a configured instance (seeded from the build-time env), so the gate never blocks.
// On native this module is evaluated before runtimeConfig.hydrate() resolves, so the config cache is always empty here.
// index.jsx dispatches setInstance once hydration completes.
const initialConfig = isNativePlatform() ? null : getConfig();

export const initialState = {
  configured: initialConfig != null,
  host: initialConfig?.host ?? null,
  webAppBaseUrl: initialConfig?.webAppBaseUrl ?? null
};

const instanceSlice = createSlice({
  name: 'instance',
  initialState,
  reducers: {
    setInstance: (state, action) => {
      state.configured = true;
      state.host = action.payload?.host ?? null;
      state.webAppBaseUrl = action.payload?.webAppBaseUrl ?? null;
    },
    clearInstance: (state) => {
      state.configured = false;
      state.host = null;
      state.webAppBaseUrl = null;
    }
  }
});

export const { setInstance, clearInstance } = instanceSlice.actions;

export default instanceSlice.reducer;
